import { DateTime } from "luxon"
import { apiPath } from "@/api/api-path"
import axios from "axios"
import qs from "qs"
import store from "@/store/index"

import api from "./service"

let tokenForExternal

function setTokenFromVuex() {
  tokenForExternal = store.state.appPermission.token
}

//
// User (New)
//
export async function getAllUserList(params) {
  return api
    .get(apiPath.getAllUserList, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Workload (New)
//
export async function getWorkloadList(params) {
  return api
    .get(apiPath.getWorkloadList, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// User Preferences (Notification Enabled Sound)
//
export async function getUserPreference() {
  return api
    .get(apiPath.getUserPreferences)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateUserPreference(data) {
  return api
    .put(apiPath.updateUserPreferences, data)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

//
// Contract
//
export async function getAllServices(params) {
  return api
    .get(apiPath.getAllServices, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function toggleServiceDeprecated(serviceId, isDeprecated) {
  const path = apiPath.toggleServiceDeprecated.replace("{serviceId}", serviceId)
  return api
    .patch(path, { deprecated: isDeprecated })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function togglePackageDeprecated(
  serviceId,
  packageId,
  isDeprecated
) {
  let path = apiPath.togglePackageDeprecated.replace("{serviceId}", serviceId)
  path = path.replace("{packageId}", packageId)
  return api
    .patch(path, { deprecated: isDeprecated })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateServiceDetail(serviceId, request) {
  const path = apiPath.updateServiceDetail.replace("{serviceId}", serviceId)
  return api
    .put(path, request)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
      console.error(error)
    })
}

export async function getServicesName() {
  return api
    .get(apiPath.getServicesName)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getServiceById(serviceId) {
  return api
    .get(apiPath.getServiceById + serviceId)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addService(request) {
  return api
    .post(apiPath.addService, request)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteService(id) {
  return api
    .delete(apiPath.deleteServiceById + id)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editServiceName(id, name) {
  return api
    .patch(apiPath.updateServiceName + id + "/name", name)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getServiceAndPackageNameList() {
  return api
    .get(apiPath.getServiceAndPackageNameList)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPackageNameListByServiceId(serviceId) {
  const path = apiPath.getPackageNameListByServiceId.replace(
    "{serviceId}",
    serviceId
  )
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getServiceAndPackageDetailById(serviceId, packageId) {
  let path = apiPath.getServiceAndPackageDetailById.replace(
    "{serviceId}",
    serviceId
  )
  path = path.replace("{packageId}", packageId)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function generateUserCustomer(generateAccountData) {
  return api
    .post(apiPath.generateUserCustomer, generateAccountData)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContractNote(contractId) {
  const path = apiPath.getContractNote.replace("{contractId}", contractId)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewContractNote(contractId, noteData) {
  const path = apiPath.createNewContractNote.replace("{contractId}", contractId)
  return api
    .post(path, noteData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteContractNote(contractId, noteId) {
  let path = apiPath.deleteContractNote.replace("{contractId}", contractId)
  path = path.replace("{noteId}", noteId)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateContractById(contractId, contractDetail) {
  const path = apiPath.updateContractById.replace("{contractId}", contractId)
  return api
    .put(path, contractDetail)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadContractAttachment(contractId, attachmentsData) {
  const path = apiPath.uploadContractAttachment.replace(
    "{contractId}",
    contractId
  )

  let formData = new FormData()
  formData.append("Title", attachmentsData.name)
  formData.append("Description", attachmentsData.description)
  for (let tag of attachmentsData.tags) {
    formData.append("Tags", tag)
  }
  for (let file of attachmentsData.uploadFile) {
    formData.append("Files", file)
  }
  return api
    .post(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function editContractAttachment(contractId, attachmentsData) {
  const path = apiPath.editContractAttachment
    .replace("{contractId}", contractId)
    .replace("{attachmentId}", attachmentsData.id)

  let formData = new FormData()
  formData.append("Title", attachmentsData.name)
  formData.append("Description", attachmentsData.description)
  for (let tag of attachmentsData.tags) {
    formData.append("Tags", tag)
  }
  return api
    .put(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteContractAttachment(contractId, attachmentsData) {
  const path = apiPath.deleteContractAttachment
    .replace("{contractId}", contractId)
    .replace("{attachmentId}", attachmentsData.id)

  return api
    .delete(path, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Ticket
//

export async function getTicketList(filter) {
  return api
    .get(apiPath.getTicketList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalTicketList(filter) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalTicketList, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTicketById(id) {
  return api
    .get(apiPath.getTicketById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getExternalTicketById(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalTicketById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getCustomerNameList() {
  return api
    .get(apiPath.getCustomerNameList)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContractList(filter) {
  return api
    .get(apiPath.getContractList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContractStatusCount(params) {
  return api
    .get(apiPath.getContractStatusCount, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function createNewContract(newContractDetail) {
  return api
    .post(apiPath.createNewContract, newContractDetail)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function changeContractStatus(contractId, status) {
  const path = apiPath.changeContractStatus.replace("{contractId}", contractId)
  return api
    .patch(path, { status })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContractByIdcId(idcId) {
  return api
    .get(apiPath.getContractByIdcId + idcId)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error.response
    })
}

export async function getExternalContractByIdcId(idcId) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getContractByIdcId + idcId, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContractNameList(siteIdPermissions) {
  return api
    .get(apiPath.getContractNameList, {
      params: {
        ...siteIdPermissions,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getFormList() {
  return api
    .get(apiPath.getFormList)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContactPointForm(contractId, formId, requestFormData) {
  let path = apiPath.getContactPointForm.replace("{contractId}", contractId)
  path = path.replace("{formId}", formId)
  return api
    .post(path, requestFormData, {
      responseType: "blob",
    })
    .then((response) => {
      if (response.status === 200) {
        const href = URL.createObjectURL(response.data)
        const link = document.createElement("a")
        link.href = href
        link.setAttribute("download", requestFormData.formName + ".pdf")
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        return response.data
      }
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTopicList() {
  return api
    .get(apiPath.getTopicList)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewTicketTopic(newTicketTopic) {
  return api
    .post(apiPath.createNewTicketTopic, newTicketTopic)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateTicketTopic(ticketTopicId, editedTicketTopic) {
  const path = apiPath.updateTicketTopic.replace(
    "{ticketTopicId}",
    ticketTopicId
  )
  return api
    .put(path, editedTicketTopic)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalTopicList() {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalTopicList, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTopicById(id) {
  return api
    .get(apiPath.getTopicById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalTopicById(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalTopicById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewTicket(request) {
  return api
    .post(apiPath.createNewTicket, request)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      throw error.response?.data?.Message
    })
}

export async function createNewExternalTicket(request) {
  setTokenFromVuex()
  return axios
    .post(apiPath.createNewExternalTicket, request, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadTicketAttachments(id, attachment) {
  let formData = new FormData()
  for (let file of attachment) {
    formData.append("files", file)
  }
  return api
    .patch(`${apiPath.uploadTicketAttachments}${id}/attachments`, formData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteTicketAttachment(ticketId, attachmentId) {
  let path = apiPath.deleteTicketAttachment.replace("{ticketId}", ticketId)
  path = path.replace("{attachmentId}", attachmentId)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadExternalTicketAttachments(id, attachment) {
  setTokenFromVuex()
  let formData = new FormData()
  for (let file of attachment) {
    formData.append("files", file)
  }
  return axios
    .patch(
      `${apiPath.uploadExternalTicketAttachments}${id}/attachments`,
      formData,
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteExternalTicketAttachment(ticketId, attachmentId) {
  setTokenFromVuex()
  let path = apiPath.deleteExternalTicketAttachment.replace(
    "{ticketId}",
    ticketId
  )
  path = path.replace("{attachmentId}", attachmentId)
  return axios
    .delete(path, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getThreadByTicketId(id, type) {
  return api
    .get(apiPath.getThreadByTicketId + id + "/threads", {
      params: {
        ThreadType: type,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalThreadByTicketId(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalThreadByTicketId + id + "/threads", {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateTicketById(id, request) {
  return api
    .put(apiPath.updateTicketById + id, request)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error.response?.data?.Message
    })
}

export async function addThreadByTicketId(id, request) {
  return api
    .post(apiPath.addThreadByTicketId + id + "/threads", request)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addExternalThreadByTicketId(id, request) {
  setTokenFromVuex()
  return axios
    .post(apiPath.addExternalThreadByTicketId + id + "/threads", request, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadThreadAttachments(threadId, ticketId, attachments) {
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("files", file)
  }
  return api
    .patch(
      `${apiPath.uploadThreadAttachments}${ticketId}/threads/${threadId}/attachments`,
      formData
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteThreadAttachment(ticketId, threadId, attachmentId) {
  let path = apiPath.deleteThreadAttachment
    .replace("{ticketId}", ticketId)
    .replace("{threadId}", threadId)
    .replace("{attachmentId}", attachmentId)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadExternalThreadAttachments(
  threadId,
  ticketId,
  attachments
) {
  setTokenFromVuex()
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("files", file)
  }
  return axios
    .patch(
      `${apiPath.uploadExternalThreadAttachments}${ticketId}/threads/${threadId}/attachments`,
      formData,
      {
        headers: {
          Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function deleteExternalThreadAttachment(
  ticketId,
  threadId,
  attachmentId
) {
  setTokenFromVuex()
  let path = apiPath.deleteExternalThreadAttachment
    .replace("{ticketId}", ticketId)
    .replace("{threadId}", threadId)
    .replace("{attachmentId}", attachmentId)
  return axios
    .delete(path, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function replyTemplates() {
  return api
    .get(apiPath.replyTemplates)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function replyTemplateById(id) {
  return api
    .get(apiPath.replyTemplateById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewReplyTemplate(newReplyTemplate) {
  return api
    .post(apiPath.createNewReplyTemplate, newReplyTemplate)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateReplyTemplate(
  replyTemplateId,
  editedReplyTemplate
) {
  const path = apiPath.updateReplyTemplate.replace(
    "{templateId}",
    replyTemplateId
  )
  return api
    .put(path, editedReplyTemplate)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Parcel Tracking
//

export async function getParcelList(filter) {
  return api
    .get(apiPath.getParcelList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalParcelList(filter) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getParcelList, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getParcelById(id) {
  return api
    .get(apiPath.getParcelById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalParcelById(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getParcelById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function receiveParcel(id, request) {
  return api
    .post(apiPath.receiveParcel + id + "/receive", request)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewParcel(request) {
  return api
    .post(apiPath.createNewParcel, request)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewExternalParcel(request) {
  setTokenFromVuex()
  return axios
    .post(apiPath.createNewParcel, request, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteParcel(id) {
  return api
    .delete(apiPath.deleteParcel + id)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteExternalParcel(id) {
  setTokenFromVuex()
  return axios
    .delete(apiPath.deleteParcel + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateParcel(id, request) {
  return api
    .put(apiPath.updateParcel + id, request)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateExternalParcel(id, request) {
  setTokenFromVuex()
  return axios
    .put(apiPath.updateParcel + id, request, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Business Type
//

export async function getBusinessTypeList() {
  return api
    .get(apiPath.getBusinessTypeList)
    .then((response) => {
      if (response) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Location
//

export async function getLocationList(params) {
  return api
    .get(apiPath.getLocationList, {
      params,
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// IDC Database
//

export async function getContactPointAndSaleList(filter) {
  return api
    .get(apiPath.getContactPointAndSaleList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContactPointAndSaleNameList() {
  return api
    .get(apiPath.getContactPointAndSaleNameList)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSaleNameList() {
  return api
    .get(apiPath.getContactPointAndSaleNameList + "?ContactType=SALE")
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getContactPointOrSaleDetailById(contactPointOrSaleId) {
  const path = apiPath.getContactPointOrSaleDetailById.replace(
    "{contactPointId}",
    contactPointOrSaleId
  )
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewContactPointOrSale(contactPointOrSaleData) {
  return api
    .post(apiPath.createContactPointOrSale, contactPointOrSaleData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateContactPointOrSale(
  contactPointOrSaleId,
  contactPointOrSaleData
) {
  const path = apiPath.updateContactPointOrSale.replace(
    "{contactPointId}",
    contactPointOrSaleId
  )
  return api
    .put(path, contactPointOrSaleData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateProfilePicture(profilePicture, contactPointId) {
  let formData = new FormData()
  formData.append("Photo", profilePicture)
  const path = apiPath.updateProfilePicture.replace(
    "{contactPointId}",
    contactPointId
  )
  return api
    .patch(path, formData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createNewCustomer(newCustomerDetail) {
  return api
    .post(apiPath.createNewCustomer, newCustomerDetail)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function updateCustomerDetail(customerId, editedCustomerDetail) {
  const path = apiPath.updateCustomerDetail.replace("{customerId}", customerId)
  return api
    .put(path, editedCustomerDetail)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getCustomerList(filter) {
  return api
    .get(apiPath.getCustomerList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCustomerDetailById(customerId) {
  const path = apiPath.getCustomerDetailById.replace("{customerId}", customerId)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteTicketById(id) {
  return api
    .delete(apiPath.deleteTicketById + id)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteExternalTicketById(id) {
  setTokenFromVuex()
  return axios
    .delete(apiPath.deleteExternalTicketById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Inventory
//

export async function getInventoryStat(params) {
  return api
    .get(apiPath.getInventoryStat, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getInventoryList(params) {
  return api
    .get(apiPath.getInventory, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getInventoryById(id) {
  return api
    .get(apiPath.getInventoryById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateInventoryById(id, body) {
  return api
    .put(apiPath.updateInventoryById + id, body)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createInventory(body) {
  return api
    .post(apiPath.createInventory, body)
    .then((response) => {
      if (response.status === 201) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteInventory(id) {
  return api
    .delete(apiPath.deleteInventoryById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// smart hands
//

export async function getStaffList() {
  return api
    .get(apiPath.getStaffList)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSmartHandsList(params) {
  return api
    .get(apiPath.getSmartHands, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalSmartHandsList(params) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getSmartHands, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSmartHandById(id) {
  return api
    .get(apiPath.getSmartHandsById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalSmartHandById(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getSmartHandsById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadSmartHandsAttachments(id, attachments) {
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("files", file)
  }
  const path = apiPath.uploadSmartHandsAttachments.replace("{smartHandId}", id)
  return api
    .patch(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteSmartHandAttachment(smartHandId, attachmentId) {
  let path = apiPath.deleteSmartHandAttachment.replace(
    "{smartHandId}",
    smartHandId
  )
  path = path.replace("{attachmentId}", attachmentId)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteSmartHandActionAttachment(
  smartHandId,
  attachmentId,
  actionId
) {
  let path = apiPath.deleteSmartHandActionAttachment
    .replace("{smartHandId}", smartHandId)
    .replace("{attachmentId}", attachmentId)
    .replace("{actionId}", actionId)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadExternalSmartHandsAttachments(id, attachments) {
  setTokenFromVuex()
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("files", file)
  }
  const path = apiPath.uploadSmartHandsAttachments.replace("{smartHandId}", id)
  return axios
    .patch(path, formData, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteExternalSmartHandAttachment(
  smartHandId,
  attachmentId
) {
  setTokenFromVuex()
  let path = apiPath.deleteSmartHandAttachment.replace(
    "{smartHandId}",
    smartHandId
  )
  path = path.replace("{attachmentId}", attachmentId)
  return axios
    .delete(path, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateSmartHandById(id, body) {
  return api
    .put(apiPath.updateSmartHandsById + id, body)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateExternalSmartHandById(id, body) {
  setTokenFromVuex()
  return axios
    .put(apiPath.updateSmartHandsById + id, body, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createSmartHands(body) {
  return api
    .post(apiPath.createSmartHands, body)
    .then((response) => {
      if (response.status === 201) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createExternalSmartHands(body) {
  setTokenFromVuex()
  return axios
    .post(apiPath.createSmartHands, body, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 201) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateSmartHandsAction(id, body) {
  const path = apiPath.updateSmartHandsAction.replace("{smartHandId}", id)
  return api
    .post(path, body)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteSmartHand(id) {
  return api
    .delete(apiPath.deleteSmartHandsById + id)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteExternalSmartHand(id) {
  setTokenFromVuex()
  return axios
    .delete(apiPath.deleteSmartHandsById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSmartHandsAction(id) {
  const path = apiPath.getSmartHandsAction.replace("{smartHandId}", id)
  return api
    .get(path)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateStaffAction(id, data) {
  const path = apiPath.updateStaffAction.replace("{smartHandId}", id)
  return api
    .patch(path, data)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadSmartHandsAdminAttachment(
  smartHandId,
  actionId,
  attachments
) {
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("files", file)
  }
  const path = apiPath.uploadSmartHandsAdminAttachment
    .replace("{smartHandId}", smartHandId)
    .replace("{actionId}", actionId)
  return api
    .patch(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Cross Connect
export async function getCrossConnectList(params) {
  return api
    .get(apiPath.getCrossConnect, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalCrossConnectList(params) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getCrossConnect, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createCrossConnect(body) {
  return api
    .post(apiPath.createCrossConnect, body)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createExternalCrossConnect(body) {
  setTokenFromVuex()
  return axios
    .post(apiPath.createCrossConnect, body, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCrossConnectById(id) {
  return api
    .get(apiPath.getCrossConnectById + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalCrossConnectById(id) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getCrossConnectById + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateCrossConnectById(id, body) {
  return api
    .put(apiPath.updateCrossConnectById + id, body)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateExternalCrossConnectById(id, body) {
  setTokenFromVuex()
  return axios
    .put(apiPath.updateCrossConnectById + id, body, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadCrossConnectAttachments(id, attachments) {
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("Attachments", file)
  }
  const path = apiPath.uploadCrossConnectAttachments.replace(
    "{crossConnectId}",
    id
  )
  return api
    .patch(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteCrossConnectAttachment(
  crossConnectId,
  attachmentId
) {
  let path = apiPath.deleteCrossConnectAttachment.replace(
    "{crossConnectId}",
    crossConnectId
  )
  path = path.replace("{attachmentId}", attachmentId)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteCrossConnectActionAttachment(
  crossConnectId,
  attachmentId
) {
  let path = apiPath.deleteCrossConnectAttachment
    .replace("{crossConnectId}", crossConnectId)
    .replace("{attachmentId}", attachmentId)
  return api
    .delete(path, {
      params: {
        isActionAttachment: true,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadExternalCrossConnectAttachments(id, attachments) {
  setTokenFromVuex()
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("Attachments", file)
  }
  const path = apiPath.uploadCrossConnectAttachments.replace(
    "{crossConnectId}",
    id
  )
  return axios
    .patch(path, formData, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteExternalCrossConnectAttachment(
  crossConnectId,
  attachmentId
) {
  setTokenFromVuex()
  let path = apiPath.deleteCrossConnectAttachment.replace(
    "{crossConnectId}",
    crossConnectId
  )
  path = path.replace("{attachmentId}", attachmentId)
  return axios
    .delete(path, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteCrossConnect(id) {
  return api
    .delete(apiPath.deleteCrossConnect + id)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteExternalCrossConnect(id) {
  setTokenFromVuex()
  return axios
    .delete(apiPath.deleteCrossConnect + id, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCrossConnectInternalById(id) {
  return api
    .get(apiPath.getCrossConnectInternalById.replace("{crossConnectId}", id))
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateCrossConnectStatus(id, body) {
  const path = apiPath.updateCrossConnectStatus.replace("{crossConnectId}", id)
  return api
    .post(path, body)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createCrossConnectMessage(id, body) {
  const path = apiPath.createCrossConnectMessage.replace("{crossConnectId}", id)
  return api
    .post(path, body)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateCrossConnectStaffAction(id, data) {
  const path = apiPath.updateCrossConnectStaffAction.replace(
    "{crossConnectId}",
    id
  )
  return api
    .patch(path, data)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function uploadCrossConnectInternalAttachment(
  crossConnectId,
  actionId,
  attachments
) {
  let formData = new FormData()
  for (let file of attachments) {
    formData.append("Attachments", file)
  }
  const path = apiPath.uploadCrossConnectInternalAttachment
    .replace("{crossConnectId}", crossConnectId)
    .replace("{actionId}", actionId)
  return api
    .patch(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
/* IPAM */
//

export async function getSubnetList(filter) {
  return api
    .get(apiPath.getSubnetList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSubnetOptions() {
  return api
    .get(apiPath.getSubnetOptions)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSubnetIpAddressById(selectedSubnetIdx, filter) {
  const path = apiPath.getSubnetIpAddressById.replace(
    "{subnetId}",
    selectedSubnetIdx
  )
  return api
    .get(path, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSubnetAndIpTagList() {
  return api
    .get(apiPath.getSubnetAndIpTagList)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addNewSubnet(newSubnet) {
  return api
    .post(apiPath.addNewSubnet, newSubnet)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editSubnet(subnetIdx, subnetData) {
  const path = apiPath.editSubnet.replace("{id}", subnetIdx)
  return api
    .put(path, subnetData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function overrideTagsToIp(subnetId) {
  const path = apiPath.overrideTagsToIp.replace("{id}", subnetId)
  return api
    .post(path, undefined)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteSubnet(subnetIdx) {
  const path = apiPath.deleteSubnet.replace("{id}", subnetIdx)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editIpAddress(ip, subnetId, ipAddressData) {
  let path = apiPath.editIpAddress.replace("{subnetId}", subnetId)
  path = path.replace("{ip}", ip)
  return api
    .put(path, ipAddressData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editMultipleIpAddress(subnetId, ipAddressData) {
  let path = apiPath.editMultipleIpAddress.replace("{subnetId}", subnetId)
  return api
    .put(path, ipAddressData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addNewIpAddress(subnetId, ipAddressData) {
  let path = apiPath.addNewIpAddress.replace("{subnetId}", subnetId)
  return api
    .post(path, ipAddressData)
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function deleteIpAddress(targetIpData) {
  const path = apiPath.deleteIpAddress
    .replace("{subnetId}", targetIpData.subnetId)
    .replace("{ip}", targetIpData.ipAddress)
  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function deleteMultipleIpAddress(targetIpAddressesData) {
  const path = apiPath.deleteMultipleIpAddress.replace(
    "{subnetId}",
    targetIpAddressesData.subnetId
  )
  return api
    .delete(path, {
      data: {
        ipAddresses: targetIpAddressesData.ipAddresses,
      },
      paramsSerializer: (data) => {
        return qs.stringify(data)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getExportReportWebPortal(type, filter, name) {
  return api
    .get(apiPath.exportReportWebPortal + type, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
      responseType: "blob",
    })
    .then((response) => {
      if (response.status === 200) {
        const href = URL.createObjectURL(response.data)
        const link = document.createElement("a")
        link.href = href
        if (type === "workload") {
          link.setAttribute(
            "download",
            `${name}${
              filter?.isAllUsers
                ? "_All_Users_in_Site"
                : `_${filter.username}`
            }_${DateTime.now().toFormat("yyyy-MM-dd")}.xlsx`
          )
        } else {
          link.setAttribute(
            "download",
            `${name}_${DateTime.now().toFormat("yyyy-MM-dd")}.xlsx`
          )
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        return response
      } else if (response.status === 204) {
        return response
      }
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getPreviewReportWebPortal(type, filter) {
  return api
    .get(apiPath.previewReportWebPortal + type, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) {
        return response.data
      }
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getIpamSubnetsList(filter) {
  return api
    .get(apiPath.getIpamSubnetsList, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAttachments(filter) {
  return api
    .get(apiPath.getAttachments, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getSharedTags(filter, isInternal = false) {
  if (isInternal) {
    return api
      .get(apiPath.getSharedTags, {
        params: filter, //tagTypes = 1 is contract ,tagTypes = 2 is site access
        paramsSerializer: (params) => {
          return qs.stringify(params)
        }
      })
      .then((response) => {
        if (response.status === 200) return response.data.data
      })
      .catch((error) => {
        console.error(error)
      })
  } else {
    setTokenFromVuex()
    return axios
      .get(apiPath.getSharedTags, {
        headers: {
          Authorization: "Bearer " + tokenForExternal
        },
        params: filter, //tagTypes = 1 is contract ,tagTypes = 2 is site access
        paramsSerializer: (params) => {
          return qs.stringify(params)
        }
      })
      .then((response) => {
        if (response.status === 200) return response.data.data
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export async function deleteContractAttachmentsById(id, idcId) {
  let path = apiPath.deleteContractAttachmentsById
  path = path.replace("{contractId}", idcId)
  path = path.replace("{attachmentId}", id)

  return api
    .delete(path)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExternalContractsById() {
  setTokenFromVuex()
  return axios
    .get(apiPath.getExternalContractsById, {
      headers: {
        Authorization: "Bearer " + tokenForExternal,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}
